// src/lib/supabase.ts
import { supabase } from '@/integrations/supabase/client';
import { StudentProfile } from '@/Types/DataTypes';

/**
 * 获取当前用户的 user profiles
 * @returns { Student }
 */
export async function getStudentProfile(): Promise<StudentProfile> {
  const { data, error } = await supabase.rpc("get_student");

  if (error) {
    console.error('Failed to fetch user profile:', error);
    throw new Error(error.message || "Failed to fetch user profile");
  }
  return data;
  // if (token) {
  //   const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/rest/v1/rpc/get_student`, {
  //     method: "POST",
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  //       "Content-Type": "application/json",
  //       Prefer: "return=representation",
  //     },
  //     body: JSON.stringify({}),
  //   });

  //   if (!response.ok) {
  //     const errorText = await response.text();
  //     console.error("getStudentProfile failed:", errorText);
  //     return null;
  //   }
  //   return await response.json();

  // }
}

/**
 * 检查用户 email 是否注册过
 * @returns { Student }
 */
export async function checkEmailExist(email: string): Promise<boolean> {
  const { data, error } = await supabase.rpc('check_email_exists', {
    email_input: email
  });

  if (error) {
    console.error('Failed to check user email:', error);
    throw new Error(error.message || "Failed to check user email");
  }

  return !!data;
}

/*
 * Check course access
 */
export async function checkCourseAccess(
  courseId: string
): Promise<boolean> {
  const { data, error } = await supabase.rpc("check_course_access", {
    course_id: courseId,
  });

  if (error) {
    console.error("Failed to check course access:", error);
    throw new Error(error.message || "Failed to check course access");
  }

  return !!data;
}